import { useAuth } from '../hooks/useAuth';
import Loader from './Loader';

export default function AuthGuard({ token, apiKey, children }) {
  const { isAuthenticated, isLoading, error, store } = useAuth({ token, apiKey });

  if (isLoading) {
    return <Loader />;
  }

  if (error || !isAuthenticated) {
    return (
      <div className="centered-page">
        <div className="centered-box">
          <div className="icon-circle icon-circle--red">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>
          <h1 className="heading-2xl">Access Denied</h1>
          <p className="text-muted">{error || 'Unable to verify store access.'}</p>
        </div>
      </div>
    );
  }

  return children(store);
}
